export function isModKey(event: KeyboardEvent): boolean {
  return !!(event.metaKey || event.ctrlKey);
}

export function isJumpPaletteHotkey(event: KeyboardEvent): boolean {
  if (!isModKey(event) || event.altKey || event.shiftKey) {
    return false;
  }
  // Prefer event.code so layout/IME quirks don't miss Ctrl+K (Chrome omnibox also uses it).
  return event.code === 'KeyK' || event.key === 'k' || event.key === 'K';
}

export function isShortcutsHelpHotkey(event: KeyboardEvent): boolean {
  if (!isModKey(event) || event.altKey || event.shiftKey) {
    return false;
  }
  return event.key === '/' || event.code === 'Slash';
}

export function modLabel(): string {
  if (typeof navigator !== 'undefined' && /Mac|iPhone|iPad|iPod/i.test(navigator.platform || '')) {
    return '⌘';
  }
  return 'Ctrl';
}
